module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullHeight"
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "25"
    }
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "animated fadeInUp",
    attrs: {
      "desktop": "40",
      "tablet": "50"
    }
  }, [_c('mu-card-text', [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "title": _vm.$t('message.labelModifyDetails'),
      "titleClass": "largeTitle blueTitle"
    }
  }), _vm._v(" "), _c('mu-card-text', [(!_vm.$route.query.hcp) ? _c('p', [_vm._v(_vm._s(_vm.$t('message.modifySubTitle')))]) : _vm._e(), _vm._v(" "), (_vm.$route.query.hcp) ? _c('p', [_vm._v("Join the free Healthcare Professional Platform")]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 40,
        regex: /^[a-zA-Z ]*$/
      }),
      expression: "{required:true, max:40, regex: /^[a-zA-Z ]*$/}"
    }],
    staticStyle: {
      "margin-bottom": "-8px"
    },
    attrs: {
      "id": "firstnameTxt",
      "data-vv-name": "first_name",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.accountPreferencesFirstName'),
      "errorText": _vm.errors.first('first_name'),
      "label": _vm.$t('message.labelYourName'),
      "type": "text",
      "hintText": _vm.$t('message.accountPreferencesFirstName'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.firstname),
      callback: function($$v) {
        _vm.$set(_vm.model, "firstname", $$v)
      },
      expression: "model.firstname"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 40,
        regex: /^[a-zA-Z ]*$/
      }),
      expression: "{required:true, max:40, regex: /^[a-zA-Z ]*$/}"
    }],
    attrs: {
      "id": "surnameTxt",
      "data-vv-name": "last_name",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.accountPreferencesSurname'),
      "errorText": _vm.errors.first('last_name'),
      "type": "text",
      "hintText": _vm.$t('message.accountPreferencesSurname'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.surname),
      callback: function($$v) {
        _vm.$set(_vm.model, "surname", $$v)
      },
      expression: "model.surname"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "id": "emailTxt",
      "data-vv-as": _vm.$t('message.accountPreferencesEmail'),
      "label": _vm.$t('message.accountPreferencesEmail'),
      "type": "email",
      "hintText": _vm.$t('message.placeholderEmail'),
      "fullWidth": "",
      "disabled": true
    },
    model: {
      value: (_vm.model.email),
      callback: function($$v) {
        _vm.$set(_vm.model, "email", $$v)
      },
      expression: "model.email"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "id": "emailTxtV",
      "data-vv-as": _vm.$t('message.accountPreferencesEmailVerify'),
      "label": _vm.$t('message.accountPreferencesEmailVerify'),
      "type": "email",
      "hintText": _vm.$t('message.placeholderEmail'),
      "fullWidth": "",
      "disabled": true
    },
    model: {
      value: (_vm.model.email),
      callback: function($$v) {
        _vm.$set(_vm.model, "email", $$v)
      },
      expression: "model.email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mu-text-field-label"
  }, [_vm._v("\n                  Date of birth\n                ")]), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "33"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dob.day),
      expression: "dob.day"
    }],
    staticClass: "native-select",
    class: {
      'error': _vm.errors.first('birth_day')
    },
    attrs: {
      "name": "birth_day",
      "data-vv-rules": 'required',
      "data-vv-name": "birth_day",
      "data-vv-as": "day"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dob, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Day")]), _vm._v(" "), _vm._l((_vm.dobItems.days), function(day, index) {
    return _c('option', {
      key: 'day-' + index,
      domProps: {
        "value": day
      }
    }, [_vm._v(_vm._s(day) + "\n                      ")])
  })], 2)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "33"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dob.month),
      expression: "dob.month"
    }],
    staticClass: "native-select",
    class: {
      'error': _vm.errors.first('birth_month')
    },
    attrs: {
      "name": "birth_month",
      "data-vv-rules": 'required',
      "data-vv-name": "birth_month",
      "data-vv-as": "month"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dob, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Month")]), _vm._v(" "), _vm._m(0)], 2)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "33"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dob.year),
      expression: "dob.year"
    }],
    staticClass: "native-select",
    class: {
      'error': _vm.errors.first('birth_year')
    },
    attrs: {
      "name": "birth_year",
      "data-vv-rules": 'required',
      "data-vv-name": "birth_year",
      "data-vv-as": "year"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dob, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Year")]), _vm._v(" "), _vm._m(1)], 2)])], 1), _vm._v(" "), _c('p', {
    staticClass: "privacyDisclaimer",
    on: {
      "click": _vm.setTerms
    }
  }, [_c('mu-checkbox', {
    model: {
      value: (_vm.terms),
      callback: function($$v) {
        _vm.terms = $$v
      },
      expression: "terms"
    }
  }), _vm._v("\n                  " + _vm._s(_vm.$t('message.registerTermsByContinuing')) + "\n                  "), _c('a', {
    attrs: {
      "href": (_vm.siteUrl + "terms"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.registerTermsAndCondtions')))]), _vm._v("\n                  " + _vm._s(_vm.$t('message.registerTermsJoin')) + " "), _c('a', {
    attrs: {
      "href": (_vm.siteUrl + "privacy"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.registerPrivacyPolicy')))]), _vm._v(",\n                  "), _c('a', {
    attrs: {
      "href": (_vm.siteUrl + "cookies"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.registerIncludingCookie')))])], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "id": "submitBtn",
      "type": "button",
      "label": _vm.isSaving ? _vm.$t('message.labelProcessing') : _vm.$t('message.amendAppBarText'),
      "disabled": _vm.isSaving,
      "secondary": "",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isError) ? _c('alert', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "danger",
      "icon": "error"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.registerErrorUserExists')) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm.isTermsError) ? _c('alert', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "danger",
      "icon": "error"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                    Please agree to our terms and conditions\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm.isServerValidationError) ? _c('alert', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "danger",
      "icon": "error"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                    " + _vm._s(_vm.serverValidationErrorText) + "\n                  ")])]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "25"
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.dobItems.months), function(month, index) {
    return _c('option', {
      key: 'month-' + index,
      domProps: {
        "value": month
      }
    }, [_vm._v(_vm._s(_vm.localizeMonth(month.name)) + "\n                      ")])
  })
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.dobItems.years), function(year, index) {
    return _c('option', {
      key: 'year-' + index,
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year.value) + "\n                      ")])
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-092b1fea","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Register/Amend.vue
// module id = 3585
// module chunks = 1